import React from "react";

import { DropdownEntry } from "../../../config/types";

type DropdownLayerProps = {
  entries: DropdownEntry[];
  onClose: (id?: string) => void;
};

const DropdownLayer: React.FC<DropdownLayerProps> = ({ entries, onClose }) => {
  if (entries.length === 0) return null;

  const shouldBlur = entries.some((entry) => entry.withBlur);

  return (
    <>
      {shouldBlur && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Close dropdowns"
          className="fixed inset-0 z-40 backdrop-blur backdrop-brightness-90"
          onClick={() => onClose()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " " || e.key === "Escape") onClose();
          }}
        />
      )}
      {entries.map((entry) => (
        <React.Fragment key={entry.id}>{entry.node}</React.Fragment>
      ))}
    </>
  );
};

export default DropdownLayer;

